export const ALLOWED_PHONE_PREFIXES = [
    // Europe
    '+358', // Åland Islands
    '+355', // Albania
    '+376', // Andorra
    '+43', // Austria
    '+32', // Belgium
    '+387', // Bosnia and Herzegovina
    '+359', // Bulgaria
    '+385', // Croatia
    '+420', // Czech Republic
    '+45', // Denmark
    '+372', // Estonia
    '+298', // Faroe Islands
    '+358', // Finland
    '+33', // France
    '+49', // Germany
    '+350', // Gibraltar
    '+30', // Greece
    '+44', // Guernsey, Isle of Man, Jersey, UK
    '+36', // Hungary
    '+354', // Iceland
    '+353', // Ireland
    '+39', // Italy (also Vatican) +393471234567 example
    '+383', // Kosovo
    '+371', // Latvia
    '+423', // Liechtenstein
    '+370', // Lithuania
    '+352', // Luxembourg
    '+389', // North Macedonia
    '+356', // Malta
    '+373', // Moldova
    '+377', // Monaco
    '+382', // Montenegro
    '+31', // Netherlands
    '+47', // Norway, Svalbard and Jan Mayen
    '+48', // Poland
    '+351', // Portugal
    '+40', // Romania
    '+378', // San Marino
    '+381', // Serbia
    '+421', // Slovakia
    '+386', // Slovenia
    '+34', // Spain
    '+46', // Sweden
    '+41', // Switzerland
    '+380', // Ukraine
    '+379', // Vatican (alternative to +39)

    // Latin America
    '+55', // Brazil
];
